import { generateDatadogTrackingProps } from 'toolkit/environment/environment/userMonitoring.util';
import { useSettingsContext } from '../theme/settings-drawer';
import { ReemaIconComponent } from '../display/Svg/ReemaIconComponent';
import { ReemaLogoComponent } from '../display/Svg/ReemaLogoComponent';
import { useDisplayModeContext } from '../theme/display';
import { useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import {
  COMPACT_GRID_WIDTH,
  EXPANDED_GRID_WIDTH,
} from '@act/react-components/app/constants';

interface AppHeaderLogoProps {
  href?: string;
  disableAnimations?: boolean;
}

export const AppHeaderLogo = ({
  href = '/',
  disableAnimations = false,
}: AppHeaderLogoProps) => {
  const theme = useTheme();
  const { displayMode } = useDisplayModeContext();
  const isCompact = displayMode === 'compact';
  const { logoGradientColors } = useSettingsContext();
  const brandColor = theme.palette.primaryAccent.main;

  const compactWidth = parseFloat(COMPACT_GRID_WIDTH);
  const expandedWidth = parseFloat(EXPANDED_GRID_WIDTH);

  const logoElement = (
    <a {...generateDatadogTrackingProps('app-header-logo-a-1')}
      href={href}
      style={{
        width: isCompact ? compactWidth : expandedWidth,
        height: 32,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ReemaIconComponent
          color={brandColor}
          gradientColors={logoGradientColors}
          useGradient={logoGradientColors.length > 0}
          width="32px"
          height="auto"
          opacity={isCompact ? 1 : 0}
          transition={disableAnimations ? 'none' : 'opacity 0.3s 0.15s'}
        />
      </div>
      <div
        style={{
          position: 'absolute',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ReemaLogoComponent
          gradientColors={logoGradientColors}
          useGradient={logoGradientColors.length > 0}
          sx={{
            color: brandColor,
            width: '136px',
            height: 'auto',
            verticalAlign: 'middle',
            opacity: !isCompact ? 1 : 0,
            transition: disableAnimations ? 'none' : 'opacity 0.3s 0.15s',
          }}
        />
      </div>
    </a>
  );

  if (disableAnimations) {
    return logoElement;
  }

  return (
    <motion.a
      href={href}
      animate={{
        width: isCompact ? compactWidth : expandedWidth,
      }}
      transition={{ type: 'tween', duration: 0.3 }}
      style={{
        height: 32,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ReemaIconComponent
          color={brandColor}
          width="32px"
          height="auto"
          opacity={isCompact ? 1 : 0}
          transition={disableAnimations ? 'none' : 'opacity 0.3s 0.15s'}
          gradientColors={logoGradientColors}
          useGradient={logoGradientColors.length > 0}
        />
      </div>
      <div
        style={{
          position: 'absolute',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ReemaLogoComponent
          gradientColors={logoGradientColors}
          useGradient={logoGradientColors.length > 0}
          sx={{
            color: brandColor,
            width: '136px',
            height: 'auto',
            verticalAlign: 'middle',
            opacity: !isCompact ? 1 : 0,
            transition: 'opacity 0.3s 0.15s',
          }}
        />
      </div>
    </motion.a>
  );
};
